export default "__VITE_ASSET__CcB3$NVy__"